import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UsersCountryRoutes from './country';
class UserRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabledRoutes: this.routesByCountry(props.enabledRoutes),
    };
  }

  routesByCountry = (routes) => {
    return routes.length
      ? routes.reduce((countries, route) => {
          !!countries[route.country]
            ? countries[route.country].push(route)
            : (countries[route.country] = [route]);

          return countries;
        }, {})
      : routes;
  };

  flatenRoutes = () => {
    return Object.keys(this.state.enabledRoutes).reduce(
      (routes, country) => [...routes, ...this.state.enabledRoutes[country]],
      []
    );
  };

  handleChange = (country, val) => {
    this.setState(
      {
        enabledRoutes: {
          ...this.state.enabledRoutes,
          [country]: val,
        },
      },
      () => this.props.onChange(this.flatenRoutes())
    );
  };

  render() {
    const { routes, className } = this.props;
    const { enabledRoutes } = this.state;

    if (!routes.length) {
      return null;
    }

    return (
      <div className={className}>
        {Object.keys(this.routesByCountry(routes)).map((country) => (
          <UsersCountryRoutes
            key={country}
            country={country}
            routes={routes.filter((r) => r.country === country)}
            enabledRoutes={enabledRoutes[country]}
            onChange={this.handleChange}
          />
        ))}
      </div>
    );
  }
}

UserRoutes.propTypes = {
  enabledRoutes: PropTypes.array.isRequired,
  routes: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default UserRoutes;
